import { render, staticRenderFns } from "./PointCardItem.vue?vue&type=template&id=c03c4bc8&scoped=true&"
import script from "./PointCardItem.vue?vue&type=script&lang=js&"
export * from "./PointCardItem.vue?vue&type=script&lang=js&"
import style0 from "./PointCardItem.vue?vue&type=style&index=0&id=c03c4bc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03c4bc8",
  null
  
)

export default component.exports